<style lang="stylus">
    .usertask
        position relative
        width 100vw
        height 100vh
        pointer-events none
        user-select none
        z-index 10

        .usertask-modal-content
            min-height 380px
            margin  0 20px
            background #fff
            border-radius 8px
            overflow hidden
</style>

<template>
    <div class="usertask" v-if="useUserTask && loaded">
        <!-- <UserTaskFloat
            :customOffset="customOffset"
            :showBox="showBox"
            @toggleShow="toggleShow"
            @contextEvent="contextEvent"
        />
        <UserTaskBox
            :customOffset="customOffset"
            :showBox="showBox"
            :progress="progress"
            :taskList="taskList"
            @clickTask="clickTask"
            @close="toggleShow"
        /> -->
        <WContextmenu :show="showContext" :left="contextLeft" :top="contextTop" @clickItem="clickItem" @clickOutside="clickOutside" />
        <UserTaskModal :show="showTaskModal" :title="taskModalTitle" :content="taskModalContent" @closeModal="closeTaskModal">
            <div class="usertask-modal-content">
                <video v-if="taskId == 1" :src="taskVideoUrl" autoplay controls width="600" height="380" @ended="videoEnd"></video>
                <img v-else :src="taskGifUrl" alt="" />
            </div>
        </UserTaskModal>
        <UserTaskQuestionModal
            :show="showQuestionModal"
            :title="questionModalTitle"
            :content="questionModalContent"
            :subTaskId="subTaskId"
            @closeModal="closeQuestionModal"
            @questionEnd="questionEnd"
        ></UserTaskQuestionModal>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    // import UserTaskFloat from "./UserTaskFloat.vue";
    import UserTaskBox from "./UserTaskBox.vue";
    import WContextmenu from "../WContextmenu.vue";
    import UserTaskModal from "./UserTaskModal.vue";
    import UserTaskQuestionModal from "./UserTaskQuestionModal.vue";
    @Component({
        components: {
            // UserTaskFloat,
            UserTaskBox,
            WContextmenu,
            UserTaskModal,
            UserTaskQuestionModal,
        },
    })
    export default class UserTask extends Vue {
        @Prop()
        customOffset;
        loaded = false;
        lockAction = false;
        useUserTask = true;
        showBox = false;

        get apiParam() {
            return this.$store.getters.apiParam;
        }
        get taskGifUrl() {
            switch (this.taskId) {
                case 2:
                    return require("@/public/img/task/img-new.gif");
                case 3:
                    return require("@/public/img/task/img-share.gif");
                case 4:
                    return require("@/public/img/task/img-publish.gif");
            }
        }

        /**float event */
        toggleShow() {
            this.changeFloatShow(!this.showBox);

            let localData = localStorage.getItem("hidden-userTaskFloat");
            let list = localData ? JSON.parse(localData) : [];
            if (this.showBox) {
                if (list.includes(this.apiParam.id)) {
                    for (let i = 0; i < list.length; i++) {
                        if (list[i] == this.apiParam.id) {
                            list.splice(i, 1);
                            break;
                        }
                    }
                }
            } else {
                list.push(this.apiParam.id);
            }
            localStorage.setItem("hidden-userTaskFloat", JSON.stringify(list));
        }

        changeFloatShow(status) {
            this.showBox = status;
        }

        /**context event */
        showContext = false;
        contextLeft = 0;
        contextTop = 0;
        contextEvent(e) {
            this.contextLeft = e.left;
            this.contextTop = e.top;
            this.showContext = true;
        }

        clickItem(e) {
            this.showContext = false;
            this.useUserTask = false;
            this.changeFloatShow(false);

            let localData = localStorage.getItem("hidden-userTask");
            let list = localData ? JSON.parse(localData) : [];
            !list.includes(this.apiParam.id) && list.push(this.apiParam.id);
            localStorage.setItem("hidden-userTask", JSON.stringify(list));

            // 展示tips
            console.log(11);
            let showTips = localStorage.getItem("hidden-userTaskTips");
            let listTips = showTips ? JSON.parse(showTips) : [];
            if (!listTips.includes(this.apiParam.id)) {
                this.$bus.$emit("showUserTaskTips");
            }
        }

        clickOutside() {
            this.showContext = false;
        }

        /**taskbox event */
        taskId = 0;
        taskList = [
            {
                id: 0,
                name: "video",
                status: 0,
            },
            {
                id: 1,
                name: "newfile",
                status: 0,
            },
            {
                id: 2,
                name: "share",
                status: 0,
            },
            {
                id: 3,
                name: "publish",
                status: 0,
            },
            {
                id: 4,
                name: "question",
                status: 0,
            },
        ];
        subTaskId = [];
        get progress() {
            let num = this.taskList.filter((item) => item.status == 1).length;
            return Math.trunc((num / this.taskList.length) * 100) / 100;
        }
        clickTask(e) {
            if (!this.loaded || this.lockAction) return;
            this.taskId = e.id;
            if (this.taskId == 5) {
                // 小调查id=5
                this.questionModalTitle = this.$t("title-question").toString();
                this.questionModalContent = this.$t("content-question").toString();
                this.showQuestionModal = true;
                this.changeFloatShow(false);
                this.subTaskId = e.subs.map((item) => item.id);
            } else {
                this.taskModalTitle = this.$t(`title-${e.name}`).toString();
                this.taskModalContent = this.$t(`content-${e.name}`).toString();
                this.showTaskModal = true;
                this.changeFloatShow(false);
                // this.taskVideoUrl = 'https://pixsoapi.edrawsoft.cn/api/helpcenter/video/helpcenter+file+9jz8HOiuSaT9ojOYswMOig==';
            }
        }

        /**modal */
        showTaskModal = false;
        taskModalTitle = "";
        taskModalContent = "";
        taskVideoUrl = "";

        showQuestionModal = false;
        questionModalTitle = "";
        questionModalContent = "";

        closeTaskModal() {
            // let openFlag = true;
            this.showTaskModal = false;
            // for(let item of this.taskList) {
            //     if(item.id == this.taskId && item.status == 1) {
            //         openFlag = false;
            //     }
            // }
            // openFlag && (this.showBox = true);
            this.checkTaskDone();
        }

        uploadTaskSucc(taskId) {
            this.lockAction = true;
            return this.$edApi
                .completeUserTask({
                    user_id: this.apiParam.id,
                    token: this.apiParam.token,
                    task_id: taskId,
                    status: 1,
                })
                .then(() => {})
                .finally(() => {
                    this.lockAction = false;
                });
        }

        videoEnd(e) {
            console.log(e, this.taskId);
            this.uploadTaskSucc(this.taskId).then(() => {
                console.log(1);
                this.changeTaskStatus(this.taskId, 1);
                this.$bus.$emit("userTaskSucc");
            });
        }

        closeQuestionModal() {
            // let openFlag = true;
            this.showQuestionModal = false;
            // for(let item of this.taskList) {
            //     if(item.id == this.taskId && item.status == 1) {
            //         openFlag = false;
            //     }
            // }
            // openFlag && (this.showBox = true);
            this.checkTaskDone();
        }

        questionEnd() {
            this.uploadTaskSucc(this.taskId).then(() => {
                console.log(1);
                this.changeTaskStatus(this.taskId, 1);
                this.$bus.$emit("userTaskSucc");
            });
        }

        checkTaskDone() {
            // 全部任务完成，展示动画
            if (this.progress == 1 && this.showBox) {
                setTimeout(() => {
                    // console.log('恭喜你 小学毕业了')
                }, 1000);
            }
        }

        changeTaskStatus(id, status) {
            for (let item of this.taskList) {
                if (item.id == id) {
                    item.status = status;
                }
            }
        }

        getTaskList() {
            return this.$edApi
                .getUserTaskList({
                    user_id: this.apiParam.id,
                    token: this.apiParam.token,
                    offset: 0,
                    count: 6,
                    lang: this.lang,
                })
                .then((data) => {
                    const nameList = ["", "video", "newfile", "share", "publish", "question"];
                    this.taskList = [];
                    this.taskVideoUrl = data[0] ? data[0].link : "";
                    for (let i = 0; i < data.length; i++) {
                        let item = data[i];
                        item.name = nameList[i + 1];
                        this.taskList.push(item);
                    }
                    this.loaded = true;
                    if (data.length != 0) {
                        this.$store.commit("toPublicStatus", {
                            type: "onUserTask",
                            data: true,
                        });
                    }
                });
        }

        isShow() {
            let localData = localStorage.getItem("hidden-userTask");
            let list = localData ? JSON.parse(localData) : [];
            let hiddenFloat = localStorage.getItem("hidden-userTaskFloat"); // 用户是否主动点击过icon
            let hiddenFloatList = hiddenFloat ? JSON.parse(hiddenFloat) : [];

            let allDone = this.taskList.filter((item) => item.status == 0).length == 0;
            if (list.includes(this.apiParam.id) || allDone || this.isPC) {
                this.useUserTask = false;
                this.$bus.$emit("getUserTaskDone"); // 非新用户，可显示入门视频弹窗
            } else {
                if (!hiddenFloatList.includes(this.apiParam.id)) {
                    // 用户收起新手帮助后不主动弹出
                    this.changeFloatShow(true);
                }
            }
            if (this.taskList.filter((item) => item.status == 0 && item.id == 2).length > 0) {
                this.$store.commit("toPublicStatus", {
                    type: "createFileTaskFlag",
                    data: true,
                });
            }
        }
        visibilityFit() {
            let state = document.visibilityState;
            if (state == "visible" && this.$validateLogin(false)) {
                this.getTaskList().then(() => {
                    this.isShow();
                });
            }
        }

        mounted() {
            document.addEventListener("visibilitychange", this.visibilityFit);
            if (this.$validateLogin(false)) {
                this.getTaskList().then(() => {
                    this.isShow();
                });
            } else {
                this.$bus.$on("loginSucc-userTask", () => {
                    this.getTaskList().then(() => {
                        this.isShow();
                    });
                });
            }
        }

        created() {
            this.$bus.$on("forceClose", () => {
                this.changeFloatShow(false);
            });
            this.$bus.$on("useUserTask", () => {
                this.useUserTask = true;
                this.changeFloatShow(false);
                setTimeout(() => {
                    // if(!this.loaded || this.useUserTask) return
                    this.changeFloatShow(!this.showBox);
                    let localData = localStorage.getItem("hidden-userTask");
                    let list = localData ? JSON.parse(localData) : [];
                    for (let i = 0; i < list.length; i++) {
                        if (list[i] == this.apiParam.id) {
                            list.splice(i, 1);
                            break;
                        }
                    }
                    localStorage.setItem("hidden-userTask", JSON.stringify(list));
                }, 100);
            });
            this.$bus.$on("changeUserTaskStatus", (data) => {
                if (!this.loaded) return;
                let { id, status } = data;
                let done = this.taskList.filter((item) => item.id == id && item.status == 1).length > 0;
                if (status == 1 && !done) {
                    this.uploadTaskSucc(id).then(() => {
                        this.changeTaskStatus(id, status);
                        !data.noAnimation && this.$bus.$emit("userTaskSucc");
                    });
                }
            });
        }

        beforeDestroy() {
            this.$bus.$off("useUserTask");
            this.$bus.$off("changeUserTaskStatus");
            this.$bus.$off("loginSucc-userTask");
            document.removeEventListener("visibilitychange", this.visibilityFit);
        }
    }
</script>
<i18n>
{
    "zh": {
        "title-video": "入门视频",
        "content-video": "观看完入门视频，关闭弹窗后任务奖励将自动发放哦~",
        "title-newfile": "新建文件",
        "content-newfile": "新建空白文件即可完成任务获取奖励哦！",
        "title-share": "导出/分享文件",
        "content-share": "导出/分享一个文件即可完成任务获取奖励哦！",
        "title-publish": "发布模板",
        "content-publish": "发布一个模板文件即可完成任务获取奖励哦！",
        "title-question": "小调查",
        "content-question": "完成一些问题选择提交，你将自动获得任务奖励"
    },
    "en": {
        "title-video": "Getting Started Video",
        "content-video": "After watching the introductory video, the task rewards will be automatically distributed after closing the pop-up window.~",
        "title-newfile": "Create a new file",
        "content-newfile": "Create a new blank file to complete the task and get rewards!",
        "title-share": "Export/share files",
        "content-share": "Export/share a file to complete the task and get rewards!",
        "title-publish": "Publish template",
        "content-publish": "Publish a template file to complete the task and get rewards!",
        "title-question": "Survey",
        "content-question": "Complete some questions and choose to submit them, and you will automatically receive task rewards"
    }
}
</i18n>
